import { IConfig } from "./Render";
export const Td = ({className, id, children, style, colspan}:IConfig)=>
{
    return (
        <td id={id} className={className} style={style} colSpan={colspan}>{children}</td>
    );
}